// extracted by mini-css-extract-plugin
module.exports = {"first-section":"header_first-section___6a8j","item":"header_item__GedAW"};